<template>
  <div>
    <px-lista-links class="mb-4" :links="links" :loading="loading"/>
  </div>
</template>

<script>
import CompraService from '@/modules/compra/compra-service';

export default {
  props: {
    compra: Object,
  },
  data() {
    return {
      loading: false,
      links: [],
    };
  },
  methods: {
    getLinks() {
      this.loading = true;
      CompraService.getLinks(this.compra.id)
        .then(({ data }) => {
          this.links = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getLinks();
  },
};
</script>
